import React, { useState, useRef, useEffect } from 'react';
import "./contactXLarge.css"
import "./contact.css"
import "./contactMedium.css"
import "./contactSmall.css"
import "./contactXSmall.css" 


const Contact = () => {
  const [isDark, setIsDark] = useState(false)
  const myRef = useRef()
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {entries.forEach(entries => {
          if (!entries.isIntersecting) {
            setIsDark(true)
          } else {
            setIsDark(false)
          }
        }
        )
      },
      {threshold: 0.5,}
    )
    observer.observe(myRef.current)
  })

  const [isConnected, setIsConnected] = useState(false)
  const ConnectRef = useRef()
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {entries.forEach(entries => {
          if (!entries.isIntersecting) {
            setIsConnected(false)
          } else {
            setIsConnected(true)
          }
        }
        )
      },
      {threshold: 0.5,}
    )
    observer.observe(myRef.current)
  })

  return (
    <>
    <section ref={myRef} className={`${isDark ? 'contact-wrapper darkBackground ' : "contact-wrapper transparent_background" }`}>
            <div className='darkShadow-reverse'></div>
            <div className='space-between'>
                <div ref={ConnectRef} className="contact-title-wrapper" id='contact'>
                    <h1 className={`${isConnected ? 'let leted' : 'let leting'}`}>
                        LET'S
                    </h1>
                    <h1 className={`${isConnected ? 'connect connected' : 'connect connecting'}`}>
                      CONNECT
                    </h1>
                </div>

              <div className='contact-info-wrapper'>
                <div className='contact-form'>
                  <form  id='form' action='https://formspree.io/f/mqkoroyk' target='_blank' method='POST' className='form'>
                    <div className='inputBox'>
                      <input 
                        type='text' 
                        name='Contact Name :' 
                        id='name' 
                        required
                      />
                      <span>Full name</span>
                    </div>
                    <div className='inputBox'>
                      <input 
                        type='text' 
                        name='Email Address :' 
                        id='email' 
                        required
                      />
                      <span>Email Address</span>
                    </div>
                    <div className='inputBox'>
                      <input 
                        type='text' 
                        name='Phone :' 
                        id='phone' 
                        required
                      />
                      <span>Phone Number</span>
                    </div>
                    <div className='inputBox'>
                      <textarea 
                        id="message" 
                        className='formMessage' 
                        name='Message :' 
                        rows="6" 
                        required
                      />
                      <span>Your message</span>
                    </div>
                    <button className='main-button hireme' type='submit'  >
                      <p>HIRE ME</p>
                    </button>
                  </form>
                </div>
              </div>
            </div>
    </section>
    </>
  )
}

export default Contact